module.exports = __webpack_public_path__ + "static/media/library.14776780.JPG";